import * as React from 'react';

import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <div className="footer--legal">
        <p>
          <a target="_blank" rel="noreferrer" href="https://spinba.se/Funding_Search_Trial_License_Agreement.pdf">
            Terms of service
          </a>
        </p>

        <p>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.spinverse.com/web/content/154605?unique=03d452f97bad4a4f4053db192bd1fd3df05fac4f&download=false"
          >
            Privacy notice
          </a>
        </p>
      </div>

      <p>Spinbase service is partly based on information from European Union open data.</p>
    </footer>
  );
};

export default Footer;
